import React, { useState, useEffect } from "react"
import { CardBody, Container, Row, Col, Card, Button, Table } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import { useHistory } from "react-router-dom"
import { URLS } from "../../Url"
import axios from "axios"
import {
  UncontrolledCarousel,
  Badge,
  ListGroup,
  ListGroupItem,
} from "reactstrap"

function ViewProduct() {
  const navigate = useHistory()
  const ProductId = sessionStorage.getItem("Productid")

  const [Product, setProduct] = useState([])
  const [thumbnailImages, setThumbnailImages] = useState([])
  const [description, setDescription] = useState("")
  const [highlights, setHighlights] = useState([])
  const [inputList, setInputList] = useState([
    { key: "", SpecificationaName: "" },
  ])

  const getAuthToken = () => {
    try {
      const authUser = localStorage.getItem("authUser")
      if (!authUser) return null
      const tokenJson = JSON.parse(authUser)
      return tokenJson?.token || null
    } catch (error) {
      console.error("Error parsing auth token:", error)
      return null
    }
  }

  const token = getAuthToken()

  useEffect(() => {
    GetOneProductData()
  }, [])

  const GetOneProductData = () => {
    const data = {
      id: ProductId,
    }

    axios
      .post(URLS.GetOneProduct, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        const productData = res?.data?.data || {}
        setProduct(productData)

        if (
          productData.specifications &&
          productData.specifications.length > 0
        ) {
          setInputList(productData.specifications)
        }

        setHighlights(
          productData.highlight?.[0] || {
            TopProduct: false,
            NewArrival: false,
            BestProduct: false,
            FeaturedProduct: false,
          }
        )

        setDescription(productData.largeDescription || "")

        if (productData.thumnailImage && productData.thumnailImage.length > 0) {
          // Prepare images for carousel
          const carouselItems = productData.thumnailImage.map((img, index) => ({
            src: `${URLS.Base}${img}`,
            altText: `Product image ${index + 1}`,
            caption: "",
            key: index,
          }))
          setThumbnailImages(carouselItems)
        }
      })
      .catch(error => {
        console.error("Error fetching product data:", error)
        toast.error("Failed to load product data")
      })
  }

  const renderBooleanHighlight = value => {
    return value ? (
      <b color="primary" className="text-success">
        Yes
      </b>
    ) : (
      <b color="danger" className="text-danger">
        No
      </b>
    )
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Bizzmate Supplier" breadcrumbItem="View Product" />
        <Card>
          <CardBody>
            <Row className="mb-3">
              <Col>
                <Button
                  onClick={() => navigate.goBack()}
                  style={{ float: "right" }}
                  color="primary"
                  size="sm"
                >
                  <i className="far fa-arrow-alt-circle-left me-2"></i>
                  Back
                </Button>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col lg={6}>
                <h4 className="card-title mb-2">
                  {Product.name || "Product Details"}
                </h4>

                {thumbnailImages.length > 0 ? (
                  <div
                    className="mb-2"
                    style={{ height: "400px", overflow: "hidden" }}
                  >
                    <UncontrolledCarousel
                      items={thumbnailImages}
                      indicators={thumbnailImages.length > 1}
                      controls={thumbnailImages.length > 1}
                      autoPlay={false}
                    />
                  </div>
                ) : (
                  <div className="text-center p-4 border rounded bg-light">
                    <i className="bx bx-image-alt display-4 text-muted"></i>
                    <p className="mt-2 mb-0">No images available</p>
                  </div>
                )}
              </Col>

              <Col lg={6}>
                <div className=" p-4  ">
                  <h5 className="mb-3 mt-3 pt-3">Basic Information</h5>

                  <ListGroup flush className="">
                    <ListGroupItem className="d-flex justify-content-between align-items-center">
                      <span className="fw-semibold">Store Name:</span>
                      <span>{Product.storeName || "-"}</span>
                    </ListGroupItem>
                    <ListGroupItem className="d-flex justify-content-between align-items-center">
                      <span className="fw-semibold">Product Name:</span>
                      <span>{Product.name || "-"}</span>
                    </ListGroupItem>
                    <ListGroupItem className="d-flex justify-content-between align-items-center">
                      <span className="fw-semibold">Short Name:</span>
                      <span>{Product.shortName || "-"}</span>
                    </ListGroupItem>
                    <ListGroupItem className="d-flex justify-content-between align-items-center">
                      <span className="fw-semibold">SKU:</span>
                      <span>{Product.sku || "-"}</span>
                    </ListGroupItem>
                    <ListGroupItem className="d-flex justify-content-between align-items-center">
                      <span className="fw-semibold">Status:</span>
                      <b
                        className={`text-${
                          Product.status === "active" ? "success" : "danger"
                        }`}
                      >
                        {Product.status || "-"}
                      </b>
                    </ListGroupItem>
                    <ListGroupItem className="d-flex justify-content-between align-items-center">
                      <span className="fw-semibold">Price:</span>
                      <span>{Product.price || "0.00"}</span>
                    </ListGroupItem>
                    <ListGroupItem className="d-flex justify-content-between align-items-center">
                      <span className="fw-semibold">Quantity:</span>
                      <span>{Product.stock || "0.00"}</span>
                    </ListGroupItem>
                    <ListGroupItem className="d-flex justify-content-between align-items-center">
                      <span className="fw-semibold">Weight:</span>
                      <span>{Product.weight || "0.00"}</span>
                    </ListGroupItem>
                  </ListGroup>
                </div>
              </Col>
            </Row>
            <hr></hr>
            <Row className="mb-2">
              <Col lg={12}>
                <h5 className="card-title mb-3">Product Highlights</h5>
                <div className="table-responsive">
                  <Table borderless className="mb-0">
                    <tbody>
                      <tr>
                        <td className="fw-semibold">Top Product</td>
                        <td>{renderBooleanHighlight(highlights.TopProduct)}</td>
                      </tr>
                      <tr>
                        <td className="fw-semibold">New Arrival</td>
                        <td>{renderBooleanHighlight(highlights.NewArrival)}</td>
                      </tr>
                      <tr>
                        <td className="fw-semibold">Best Product</td>
                        <td>
                          {renderBooleanHighlight(highlights.BestProduct)}
                        </td>
                      </tr>
                      <tr>
                        <td className="fw-semibold">Featured Product</td>
                        <td>
                          {renderBooleanHighlight(highlights.FeaturedProduct)}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
            <hr></hr>
            <Row className="mb-2">
              <Col lg={12}>
                <h5 className="card-title mb-3">Product Description</h5>
                <div
                  className="p-3  rounded"
                  dangerouslySetInnerHTML={{ __html: description }}
                  style={{
                    fontFamily:
                      "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    color: "#333",
                    lineHeight: "1.6",
                  }}
                />
              </Col>
            </Row>
            <hr></hr>
            <Row>
              <Col lg={12}>
                <h5 className="card-title mb-3">Specifications</h5>
                <div className="table-responsive">
                  <Table bordered hover className="mb-0">
                    <thead className="table-light">
                      <tr>
                        <th width="40%">Key</th>
                        <th>Specification</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inputList.length > 0 ? (
                        inputList.map((data, key) => (
                          <tr key={key}>
                            <td className="fw-semibold">{data.key}</td>
                            <td>{data.SpecificationaName}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="2" className="text-center text-muted">
                            No specifications available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
      <ToastContainer />
    </div>
  )
}

export default ViewProduct
